/**
 * Cobrança dos embriões que ficaram no botijão.
 *
 * O caso que a criou: o serviço é faturado POR PRENHEZ, e nem todo embrião
 * produzido vira prenhez. Os que sobraram foram vitrificados e estão no
 * botijão do laboratório ocupando espaço e nitrogênio — e saíam de graça,
 * porque o modelo por prenhez só enxerga o que foi transferido e pegou.
 *
 * SOMA, NÃO SUBSTITUI. Não é um sétimo modelo de cobrança: `billing_model`
 * continua único e responde "como este serviço é cobrado". Vitrificação e DT
 * entram por cima de qualquer um deles. Fazer disso um modelo obrigaria a
 * escolher entre cobrar a prenhez OU o congelado, que é o oposto do pedido.
 *
 * Cobra só o que foi CONTRATADO: sem `vitrificacao` em `services_offered`, a
 * linha não entra, mesmo que haja embrião vitrificado e preço preenchido. O
 * laboratório que congela por conta própria não deve cobrar por isso sem ter
 * combinado.
 */

const num = (v) => Number(v) || 0;

/** As linhas de congelamento de um serviço, já com subtotal. */
export const linhasDeCongelamento = (service = {}) => {
  const oferecidos = service.services_offered || [];
  const linhas = [];

  if (oferecidos.includes('vitrificacao')) {
    const qtd = num(service.qtd_vitrificados);
    const preco = num(service.preco_vitrificacao);
    if (qtd > 0 && preco > 0) {
      linhas.push({
        tipo: 'vitrificacao', rotulo: 'Vitrificação',
        quantidade: qtd, preco, subtotal: qtd * preco,
      });
    }
  }

  if (oferecidos.includes('dt')) {
    const qtd = num(service.qtd_dt);
    const preco = num(service.preco_dt);
    if (qtd > 0 && preco > 0) {
      linhas.push({
        tipo: 'dt', rotulo: 'DT',
        quantidade: qtd, preco, subtotal: qtd * preco,
      });
    }
  }

  // A quantidade vem do banco (`recalcula_desvitrificados`): só embrião de outro
  // laboratório conta, e a TE de um serviço pode mudar a conta de outro.
  if (oferecidos.includes('desvitrificacao')) {
    const qtd = num(service.qtd_desvitrificados);
    const preco = num(service.preco_desvitrificacao);
    if (qtd > 0 && preco > 0) {
      linhas.push({
        tipo: 'desvitrificacao', rotulo: 'Desvitrificação',
        quantidade: qtd, preco, subtotal: qtd * preco,
      });
    }
  }

  return linhas;
};

/** Quanto o congelamento acrescenta ao serviço. */
export const valorDoCongelamento = (service = {}) =>
  linhasDeCongelamento(service).reduce((s, l) => s + l.subtotal, 0);
